// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorWithIcon_error__WtpqN","message":"ErrorWithIcon_message__2Ve_o"};